import Storage from "./../../storage";
import { handleFormSecurity } from "./../../security";
import { initStripe, createPaymentMethod, handleCardAction } from "./../../stripe";
import serialize from "form-serialize";
import documentReady from "./../../helpers/document-ready";
import getQueryParams from "./../../helpers/query-params";
import formResponseHandler from "./../../helpers/form-response-handler";

let submitButton;
let invoiceIdField;
let nameOnCardField;
let intentIdField;
let isSubmitting;
let invoiceId;
let errorElement;
let invoiceUiExplanation;
let invoiceUi;
let secureNotice;

const updateUi = (params) => {
    invoiceUi = document.getElementById("c-reopen__billing-details");
    invoiceUiExplanation = document.getElementById("c-reopen__billing-explanation");

    invoiceUiExplanation.innerHTML = params.extra_days
        ? `Your Tapfiliate account is locked, because it was manually closed. You can re-open your account now by paying your next invoice. Your new monthly subscription fee will be <b>$${
              params.amount_due
          }/m</b>${params.will_pay_vat ? " (ex. VAT)" : ""}.`
        : `Your Tapfiliate account is currently locked because we were unable to collect your earlier subscription fee.`;

    invoiceUi.innerHTML = `You can re-open your account by paying the subscription amount of <b>$${
        params.amount_due
    }</b>${
        params.will_pay_vat ? " (ex. VAT)" : ""
    }.<br> As soon as you re-open, a new Tapfiliate subscription will start with the same pricing plan as you used to have. The following charge of $${
        params.new_amount
    } ${params.will_pay_vat ? " (ex. VAT)" : ""} will happen next month.
    ${
        params.extra_days
            ? `A total of ${params.extra_days} extra days from your previous billing cycle will be added to your account.`
            : ""
    }`;

    submitButton.removeAttribute("disabled");
};

const removeFields = () => {
    submitButton.remove();
    nameOnCardField.remove();
    secureNotice.remove();
};

const fetchDataForInvoice = async () => {
    const response = await fetch(
        `https://app.tapfiliate.com/billing/reopen-account/${invoiceId}/`,
        {
            credentials: "include",
        },
    );

    if (!response.ok) {
        removeFields();

        return void displayError("Invoice is not open for payment");
    }

    const params = await response.json();

    updateUi(params);

    return true;
};

const selectElements = () => {
    submitButton = document.getElementById("c-reopen__submit-button");
    invoiceIdField = document.getElementsByName("reopen_account_type[lastInvoiceId]")[0];
    intentIdField = document.getElementsByName("reopen_account_type[paymentIntentId]")[0];
    errorElement = document.getElementById("card-errors");
    secureNotice = document.getElementsByClassName("c-register__secure-notice")[0];
    nameOnCardField = document.getElementsByName("name_on_card")[0];
};

const addSubmitListener = () => {
    const form = document.getElementById("reopen-form");

    form.addEventListener("submit", (ev) => {
        ev.preventDefault();
        registerStripe(form);
    });
};

const registerStripe = async (form) => {
    if (isSubmitting || !invoiceId) return;

    const nameOnCard = nameOnCardField.value;
    setIsSubmitting(true);

    const result = await createPaymentMethod(nameOnCard);

    if (result.error) {
        displayError(result.error.message);
        return void setIsSubmitting(false);
    }

    document.getElementsByName("reopen_account_type[paymentMethodId]")[0].value =
        result.paymentMethod.id;

    doRegister(form);
};

const setIsSubmitting = (submitting) => {
    isSubmitting = submitting;

    if (submitting) {
        isSubmitting = true;
        submitButton.classList.add("c-button--loading");
        return void submitButton.setAttribute("disabled", "");
    }

    submitButton.classList.remove("c-button--loading");
    submitButton.removeAttribute("disabled");
};

const displayError = (error) => {
    errorElement.textContent = error;
};

const clearError = () => displayError(null);

const doRegister = async (form) => {
    const response = await fetch(`/billing/reopen-account/`, {
        method: "POST",
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        },
        body: serialize(form),
        credentials: "include",
    });

    const paymentIntentId = response.headers.get("X-Verify-Intent-Id");
    const paymentIntentClientSecret = response.headers.get("X-Verify-Intent-Secret");
    if (paymentIntentClientSecret) {
        const result = await handleCardAction(paymentIntentClientSecret);

        setIsSubmitting(false);

        if (result.error) {
            return void displayError(result.error.message);
        }

        clearError();

        intentIdField.value = paymentIntentId;

        doRegister(form);
        return;
    }

    formResponseHandler(response);
    setIsSubmitting(false);
};

documentReady(async () => {
    selectElements();

    invoiceId = getQueryParams()["inv"];

    if (!invoiceId) {
        return void displayError("Missing invoice id");
    }

    invoiceIdField.value = invoiceId;

    handleFormSecurity("reopen_account_type[_token]", "reopen_account_type");

    const success = await fetchDataForInvoice();

    if (!success) return;

    const stripeEl = await initStripe();
    stripeEl.focus();

    addSubmitListener();
});
